import { Button } from './ui/button';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

export function Pagination({ page, totalPages, total, onPageChange }) {
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  return (
    <div className="flex items-center justify-between mt-4 pt-3 border-t" data-testid="pagination">
      <span className="text-sm text-slate-500">
        Total {total} data{totalPages > 1 ? ` Â· Halaman ${page} dari ${totalPages}` : ''}
      </span>
      {totalPages > 1 && (
        <div className="flex items-center gap-1">
          <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPageChange(1)} title="Pertama" data-testid="page-first">
            <ChevronsLeft className="h-4 w-4" />
          </Button>
          <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)} title="Sebelumnya" data-testid="page-prev">
            <ChevronLeft className="h-4 w-4" />
          </Button>
          {getPageNumbers().map(p => (
            <Button
              key={p}
              variant={p === page ? 'default' : 'outline'}
              size="sm"
              onClick={() => onPageChange(p)}
              style={p === page ? { backgroundColor: '#ffee8b', color: '#333', borderColor: '#e5d56a' } : {}}
              data-testid={`page-${p}`}
            >
              {p}
            </Button>
          ))}
          <Button variant="outline" size="sm" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} title="Selanjutnya" data-testid="page-next">
            <ChevronRight className="h-4 w-4" />
          </Button>
          <Button variant="outline" size="sm" disabled={page >= totalPages} onClick={() => onPageChange(totalPages)} title="Terakhir" data-testid="page-last">
            <ChevronsRight className="h-4 w-4" />
          </Button>
        </div>
      )}
    </div>
  );
}


